import { collection, getDocs, limit, onSnapshot, orderBy, query, startAfter, where} from 'firebase/firestore';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../firebase/config';
import { useMsg } from '../../contextAPI/ErrorMsgContext';
import EventCard from '../../components/EventCard/EventCard';
import { useNav } from '../../contextAPI/NavContaxt';
import SearchBar from "../../components/SearchBar"
import { useAuth } from '../../contextAPI/AuthContext';
import EventShortCut from './Components/EventShortCut';
import BottomNav from '../../components/BottomNav/BottomNavEvent';
import ConfirmationBox from "../../components/ConfirmationBox"
import { handleTouchEnd, handleTouchMove, handleTouchStart } from '../../Utils/util';
import { useApp } from '../../contextAPI/AppContext';
import useNetworkStatus from '../../CustomHooks/useNetworkStatus';
import { useNetworkError } from '../../contextAPI/NetworkErrorContext';
import NoNetwork from '../../components/NoNetwork';
import BottomNavEvent from '../../components/BottomNav/BottomNavEvent';

 const EventsScreen =  () => {
    
  const navigate = useNavigate()
  const [events, setEvents] = useState([])
  const [searchEvent, setSearchEvent] = useState([])
  const {setMsgType} = useMsg()
  const {setShowNav, setTitle,setShowMenu} = useNav()
  const {setViewMode} = useApp()
  const {user} = useAuth()
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const [error, setError] = useState(null)
  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [searchValue, setSearchValue] = useState("")


  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const observer = useRef();
  const imageObserver = useRef();


  const fetchEvents = async () => {
    setLoading(true);
    let q = query(
      collection(db, 'events'),
      where('eventVisibility',"==","public"),
      where("ends" ,">=", currentDate ),
      orderBy('eventDate'),
      limit(2)
    );

    if (lastVisible) {
      q = query(
        collection(db, 'events'),
        where('eventVisibility',"==","public"),
        where("ends" ,">=", currentDate ),
        orderBy('eventDate'),
        startAfter(lastVisible),
        limit(2)
      );
    }

    try {
      const snapshot = await getDocs(q);
    const newEvents = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    console.log(newEvents)

    setEvents((prev) => [...prev, ...newEvents]);
    setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    setLoading(false);
    } catch (error) {
      console.log(error)
    }
    
  };

 
useEffect(() => {

    setShowNav(false)
    setShowMenu(true)
    setTitle("Events")
    setMsgType("success")

  
    // let unsubsctriber
    // const fetchEvents = async () => {
        
    //   try {
        
  
    //           const eventCollectionRef = collection(db,"events")
               
    //          const q = query(eventCollectionRef, where("ends" ,">=", currentDate ), where("eventVisibility", "==", "public"))
    //          unsubsctriber =  onSnapshot(q, (snapShot)=>{
    //                const eventData = []
    //                 snapShot.docs.map(doc=> eventData.push({...doc.data(), id: doc.id}))
    //                 setEvents(eventData)
    //          },(err)=>{console.log(err)})

            
    //   } catch (error) {
    //      console.log(error)
    //   }
 
    //     };

    

        fetchEvents();
        
        // return ()=>{
        //   unsubsctriber()
        // }
    }, []);


    useEffect(() => {
      imageObserver.current = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            observer.unobserve(img);
          }
        });
      });
  
      const imgs = document.querySelectorAll('img[data-src]');
      imgs.forEach(img => {
        imageObserver.current.observe(img);
      });
  
      return () => {
        if (imageObserver.current) {
          imageObserver.current.disconnect();
        }
      };
    }, [events]);

    const lastEventElementRef = useCallback(
      (node) => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            fetchEvents();
          }
        });
        if (node) observer.current.observe(node);
      },
      [loading]
    );

const goToEvent = async(event) => {
    console.log("go")
    //store the event chosen in database and local host
    // const event = events.find(event=> event.id === eventId)

    //check if event exists //later check for event status too
    
   
    localStorage.setItem("eventName",event.eventName)
    localStorage.setItem("shortcutEventId",event.id)
    localStorage.setItem("eventId", event.id)
    localStorage.setItem("createdBy",event.createdBy)
    
    //setChosenEvent(eventDoc)
      
      if(event.createdBy === user.id){
     
        navigate("/event-owner-hs")
        return
      }
      navigate("/event-page") 
  
  }

  const switchToCarpools = ()=> {
    setViewMode('carpool')
    localStorage.setItem("viewMode", 'carpool')
    navigate("/")
    
  }

  const search = (e) =>{
    setSearchValue(e.target.value)
    const filtered = events.filter(event => event.eventName.toLowerCase().includes(e.target.value.trim().toLowerCase()))
    setSearchEvent(filtered)
  }

  return (
    <>
    {localStorage.getItem("eventName") && localStorage.getItem("shortcutEventId") && <EventShortCut/>}
   <div style={{width:"100%", marginTop:"20px", display:"flex", alignItems:"center"}}>
    <SearchBar onChange={search} searchValue={searchValue}/>
    <svg width="45" height="40" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:"10px"}} onClick={switchToCarpools}>
      <rect width="45" height="40" rx="8" fill="#18181A"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9026 17.3983L12.8906 17.4063C12.3342 17.7772 12 18.4017 12 19.0704V27C12 27.5523 12.4477 28 13 28H14C14.5523 28 15 27.5523 15 27V26H29V27C29 27.5523 29.4477 28 30 28H31C31.5523 28 32 27.5523 32 27V19.0704C32 18.4017 31.6658 17.7772 31.1094 17.4063L31.0974 17.3983C31.4619 17.1878 31.792 16.981 31.8561 16.8889C32.0108 16.6667 32.0819 16 31.8561 16H30L28.8292 13.6584C28.321 12.642 27.2822 12 26.1459 12H17.8541C16.7178 12 15.679 12.642 15.1708 13.6584L14 16H12.1439C11.9181 16 11.9892 16.6667 12.1439 16.8889C12.208 16.981 12.5381 17.1878 12.9026 17.3983ZM16.102 14.0588L14.3922 17.2647C14.2145 17.5978 14.4559 18 14.8333 18H29.1667C29.5441 18 29.7855 17.5978 29.6078 17.2647L27.898 14.0588C27.5505 13.4071 26.872 13 26.1333 13H17.8667C17.128 13 16.4496 13.4071 16.102 14.0588ZM13 21.0799V19.8705C13 19.4846 13.4186 19.2442 13.7519 19.4386L17.0908 21.3863C17.5509 21.6547 17.3282 22.3607 16.7973 22.3164L13.917 22.0764C13.3987 22.0332 13 21.6 13 21.0799ZM31 19.8705V21.0799C31 21.6 30.6013 22.0332 30.083 22.0764L27.2027 22.3164C26.6718 22.3607 26.4491 21.6547 26.9092 21.3863L30.2481 19.4386C30.5814 19.2442 31 19.4846 31 19.8705Z" fill="#D9D9D9"/>
      <path d="M15.2955 34.5H15.0682C15.0445 34.3769 15.0001 34.2579 14.935 34.1431C14.8699 34.0271 14.7859 33.9229 14.6829 33.8306C14.5811 33.7371 14.4627 33.6631 14.3278 33.6087C14.1928 33.5542 14.0437 33.527 13.8803 33.527C13.6412 33.527 13.421 33.5909 13.2198 33.7188C13.0198 33.8454 12.8594 34.0318 12.7386 34.2781C12.6191 34.5243 12.5593 34.8255 12.5593 35.1818C12.5593 35.5405 12.6191 35.8429 12.7386 36.0891C12.8594 36.3353 13.0198 36.5218 13.2198 36.6484C13.421 36.7739 13.6412 36.8366 13.8803 36.8366C14.0437 36.8366 14.1928 36.81 14.3278 36.7567C14.4627 36.7023 14.5811 36.6289 14.6829 36.5366C14.7859 36.4431 14.8699 36.3383 14.935 36.2223C15.0001 36.1063 15.0445 35.9867 15.0682 35.8636H15.2955C15.2694 36.0104 15.2191 36.1542 15.1445 36.2951C15.0711 36.436 14.9741 36.5638 14.8533 36.6786C14.7338 36.7923 14.5923 36.8828 14.429 36.9503C14.2668 37.0166 14.0839 37.0497 13.8803 37.0497C13.5773 37.0497 13.3104 36.9728 13.0795 36.8189C12.8487 36.6638 12.6676 36.446 12.5362 36.1655C12.406 35.8849 12.3409 35.5571 12.3409 35.1818C12.3409 34.8066 12.406 34.4787 12.5362 34.1982C12.6676 33.9176 12.8487 33.7004 13.0795 33.5465C13.3104 33.3915 13.5773 33.3139 13.8803 33.3139C14.0839 33.3139 14.2668 33.3477 14.429 33.4151C14.5923 33.4814 14.7338 33.5714 14.8533 33.685C14.9741 33.7975 15.0711 33.9241 15.1445 34.065C15.2191 34.2058 15.2694 34.3509 15.2955 34.5ZM16.7949 37.0586C16.6375 37.0586 16.4931 37.0272 16.3617 36.9645C16.2315 36.9018 16.1267 36.81 16.0474 36.6893C15.9693 36.5685 15.9302 36.4218 15.9302 36.2489C15.9302 36.1353 15.9503 36.0353 15.9906 35.9489C16.0308 35.8625 16.093 35.7879 16.177 35.7251C16.2611 35.6624 16.3688 35.6109 16.5002 35.5707C16.6316 35.5292 16.7884 35.4973 16.9707 35.4748C17.1092 35.4582 17.2329 35.4422 17.3418 35.4268C17.4507 35.4103 17.5359 35.3848 17.5975 35.3505C17.6602 35.3162 17.6916 35.2641 17.6916 35.1942V35.0806C17.6916 34.8817 17.6288 34.7237 17.5034 34.6065C17.3779 34.4893 17.2051 34.4308 16.9849 34.4308C16.7896 34.4308 16.6251 34.474 16.4913 34.5604C16.3587 34.6456 16.2658 34.7557 16.2125 34.8906L16.0083 34.8143C16.0604 34.6841 16.1356 34.5758 16.2338 34.4893C16.3333 34.4029 16.4469 34.3384 16.5748 34.2958C16.7038 34.2532 16.8387 34.2319 16.9796 34.2319C17.1015 34.2319 17.2175 34.2491 17.3276 34.2834C17.4389 34.3177 17.5377 34.3698 17.6241 34.4396C17.7117 34.5095 17.781 34.5988 17.8319 34.7077C17.8828 34.8155 17.9082 34.9445 17.9082 35.0948V37H17.6916V36.5082H17.6756C17.6283 36.61 17.5632 36.7029 17.4803 36.7869C17.3986 36.8698 17.2998 36.9361 17.1838 36.9858C17.069 37.0343 16.9393 37.0586 16.7949 37.0586ZM16.8162 36.858C16.9867 36.858 17.1376 36.8165 17.269 36.7337C17.4016 36.6496 17.5051 36.5348 17.5797 36.3892C17.6543 36.2436 17.6916 36.0785 17.6916 35.8938V35.4925C17.6644 35.5162 17.6247 35.5375 17.5726 35.5565C17.5217 35.5742 17.4637 35.5902 17.3986 35.6044C17.3347 35.6174 17.2672 35.6293 17.1962 35.6399C17.1264 35.6494 17.0583 35.6583 16.992 35.6665C16.7931 35.6902 16.631 35.7269 16.5055 35.7766C16.3812 35.8252 16.2901 35.8891 16.2321 35.9684C16.1752 36.0477 16.1468 36.1436 16.1468 36.256C16.1468 36.4419 16.2108 36.5887 16.3386 36.6964C16.4664 36.8041 16.6257 36.858 16.8162 36.858ZM18.8164 37V34.2727H19.0277V34.6989H19.0472C19.1064 34.5592 19.2064 34.4473 19.3473 34.3633C19.4882 34.2781 19.6486 34.2354 19.8285 34.2354C19.8474 34.2354 19.8664 34.2354 19.8853 34.2354C19.9042 34.2354 19.922 34.236 19.9386 34.2372V34.4556C19.9244 34.4544 19.9072 34.4527 19.8871 34.4503C19.8681 34.4467 19.8445 34.445 19.8161 34.445C19.6645 34.445 19.5296 34.4775 19.4112 34.5426C19.294 34.6077 19.2017 34.6977 19.1342 34.8125C19.0668 34.9261 19.033 35.0563 19.033 35.2031V37H18.8164ZM22.0031 37V33.3636H23.1235C23.3543 33.3636 23.552 33.411 23.7165 33.5057C23.8823 33.6004 24.0095 33.73 24.0983 33.8945C24.1871 34.0591 24.2314 34.2467 24.2314 34.4574C24.2314 34.6657 24.1871 34.8522 24.0983 35.0167C24.0095 35.1812 23.8823 35.3114 23.7165 35.4073C23.552 35.502 23.3549 35.5494 23.1253 35.5494H22.1594V35.3434H23.1199C23.307 35.3434 23.4668 35.3055 23.5993 35.2298C23.7319 35.1528 23.8337 35.0481 23.9047 34.9155C23.9758 34.7817 24.0113 34.629 24.0113 34.4574C24.0113 34.2846 23.9758 34.1313 23.9047 33.9975C23.8337 33.8638 23.7313 33.759 23.5976 33.6832C23.465 33.6075 23.3052 33.5696 23.1182 33.5696H22.2251V37H22.0031ZM25.9924 37.0568C25.7675 37.0568 25.5674 36.9964 25.3922 36.8757C25.217 36.7538 25.0791 36.5863 24.9785 36.3732C24.8779 36.1602 24.8276 35.9175 24.8276 35.6452C24.8276 35.3718 24.8779 35.1291 24.9785 34.9173C25.0791 34.7042 25.217 34.5367 25.3922 34.4148C25.5674 34.2929 25.7675 34.2319 25.9924 34.2319C26.2173 34.2319 26.4173 34.2929 26.5925 34.4148C26.7677 34.5367 26.9056 34.7042 27.0062 34.9173C27.1068 35.1303 27.1571 35.373 27.1571 35.6452C27.1571 35.9175 27.1068 36.1602 27.0062 36.3732C26.9056 36.5863 26.7677 36.7538 26.5925 36.8757C26.4173 36.9964 26.2173 37.0568 25.9924 37.0568ZM25.9924 36.8562C26.1829 36.8562 26.3493 36.8023 26.4913 36.6946C26.6345 36.5869 26.7452 36.4413 26.8233 36.2578C26.9026 36.0743 26.9423 35.8701 26.9423 35.6452C26.9423 35.4203 26.9026 35.2167 26.8233 35.0344C26.744 34.851 26.6333 34.7054 26.4913 34.5977C26.3493 34.4888 26.1829 34.4343 25.9924 34.4343C25.8018 34.4343 25.6355 34.4888 25.4934 34.5977C25.3514 34.7054 25.2407 34.851 25.1614 35.0344C25.0821 35.2167 25.0424 35.4203 25.0424 35.6452C25.0424 35.8701 25.0815 36.0743 25.1596 36.2578C25.2389 36.4413 25.3496 36.5869 25.4917 36.6946C25.6349 36.8023 25.8018 36.8562 25.9924 36.8562ZM28.9172 37.0568C28.6923 37.0568 28.4922 36.9964 28.317 36.8757C28.1418 36.7538 28.0039 36.5863 27.9033 36.3732C27.8027 36.1602 27.7524 35.9175 27.7524 35.6452C27.7524 35.3718 27.8027 35.1291 27.9033 34.9173C28.0039 34.7042 28.1418 34.5367 28.317 34.4148C28.4922 34.2929 28.6923 34.2319 28.9172 34.2319C29.1421 34.2319 29.3421 34.2929 29.5173 34.4148C29.6925 34.5367 29.8304 34.7042 29.931 34.9173C30.0316 35.1303 30.0819 35.373 30.0819 35.6452C30.0819 35.9175 30.0316 36.1602 29.931 36.3732C29.8304 36.5863 29.6925 36.7538 29.5173 36.8757C29.3421 36.9964 29.1421 37.0568 28.9172 37.0568ZM28.9172 36.8562C29.1077 36.8562 29.2741 36.8023 29.4161 36.6946C29.5593 36.5869 29.67 36.4413 29.7481 36.2578C29.8274 36.0743 29.8671 35.8701 29.8671 35.6452C29.8671 35.4203 29.8274 35.2167 29.7481 35.0344C29.6688 34.851 29.5581 34.7054 29.4161 34.5977C29.2741 34.4888 29.1077 34.4343 28.9172 34.4343C28.7266 34.4343 28.5603 34.4888 28.4182 34.5977C28.2762 34.7054 28.1655 34.851 28.0862 35.0344C28.0069 35.2167 27.9672 35.4203 27.9672 35.6452C27.9672 35.8701 28.0063 36.0743 28.0844 36.2578C28.1637 36.4413 28.2744 36.5869 28.4165 36.6946C28.5597 36.8023 28.7266 36.8562 28.9172 36.8562ZM31.0447 33.3636V37H30.8281V33.3636H31.0447Z" fill="#A0A3AF"/>
    </svg>
    <svg width="45" height="40" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:"10px"}}>
      <rect width="45" height="40" rx="8" fill="#8E69F0"/>
      <path d="M16.25 17.625H18.25V19.625H16.25V17.625Z" fill="white"/>
      <path d="M18.25 22.375H16.25V24.375H18.25V22.375Z" fill="white"/>
      <path d="M21 17.625H23V19.625H21V17.625Z" fill="white"/>
      <path d="M23 22.375H21V24.375H23V22.375Z" fill="white"/>
      <path d="M25.75 17.625H27.75V19.625H25.75V17.625Z" fill="white"/>
      <path d="M27.75 22.375H25.75V24.375H27.75V22.375Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 13.25H12.25V28.75H31.75V13.25H28.75V10H27.25V13.25H16.75V10H15.25V13.25ZM13.75 14.75V27.25H30.25V14.75H13.75Z" fill="white"/>
      <path d="M13.6761 37V31.9091H16.6293V32.3267H14.141V34.2433H16.4727V34.6609H14.141V36.5824H16.679V37H13.6761ZM20.696 33.1818L19.3015 37H18.8292L17.4347 33.1818H17.9144L19.0479 36.4158H19.0827L20.2163 33.1818H20.696ZM22.9687 37.0795C22.6124 37.0795 22.3041 36.9967 22.0439 36.831C21.7838 36.6636 21.5824 36.4324 21.4399 36.1374C21.299 35.8408 21.2286 35.4994 21.2286 35.1133C21.2286 34.7288 21.299 34.3874 21.4399 34.0891C21.5824 33.7892 21.7788 33.5547 22.029 33.3857C22.2809 33.215 22.5718 33.1296 22.9015 33.1296C23.1087 33.1296 23.3084 33.1677 23.5006 33.244C23.6929 33.3185 23.8652 33.4337 24.0177 33.5895C24.1718 33.7436 24.2936 33.9383 24.3831 34.1737C24.4726 34.4073 24.5173 34.6841 24.5173 35.0039V35.2227H21.5344V34.8324H24.0649C24.0649 34.5871 24.0152 34.3667 23.9157 34.1712C23.818 33.974 23.6813 33.8182 23.5056 33.7038C23.3316 33.5895 23.1302 33.5323 22.9015 33.5323C22.6596 33.5323 22.4466 33.5969 22.2627 33.7262C22.0787 33.8555 21.9346 34.0262 21.8302 34.2383C21.7274 34.4504 21.6752 34.6824 21.6736 34.9343V35.168C21.6736 35.4712 21.7258 35.7364 21.8302 35.9634C21.9362 36.1888 22.0862 36.3636 22.2801 36.4879C22.474 36.6122 22.7035 36.6744 22.9687 36.6744C23.1493 36.6744 23.3076 36.6462 23.4434 36.5898C23.581 36.5335 23.6962 36.4581 23.789 36.3636C23.8834 36.2675 23.9547 36.1623 24.0028 36.0479L24.4229 36.1847C24.3648 36.3454 24.2696 36.4937 24.137 36.6296C24.0061 36.7655 23.842 36.8749 23.6448 36.9577C23.4492 37.0389 23.2239 37.0795 22.9687 37.0795ZM25.9348 34.6136V37H25.4924V33.1818H25.9224V33.7809H25.9622C26.0517 33.5853 26.1909 33.4287 26.3798 33.3111C26.5704 33.1918 26.8057 33.1321 27.0858 33.1321C27.3426 33.1321 27.568 33.186 27.7619 33.2937C27.9574 33.3997 28.1091 33.5563 28.2168 33.7635C28.3262 33.9706 28.3809 34.225 28.3809 34.5266V37H27.9384V34.554C27.9384 34.2408 27.8506 33.993 27.6749 33.8107C27.5009 33.6284 27.2672 33.5373 26.9739 33.5373C26.7734 33.5373 26.5952 33.5804 26.4395 33.6665C26.2837 33.7527 26.1602 33.877 26.0691 34.0394C25.9796 34.2002 25.9348 34.3916 25.9348 34.6136ZM31.05 33.1818V33.5671H29.2279V33.1818H31.05ZM29.7971 32.267H30.2421V36.0032C30.2421 36.1623 30.2694 36.2874 30.3241 36.3786C30.3788 36.468 30.4501 36.5318 30.5379 36.57C30.6257 36.6064 30.7194 36.6246 30.8188 36.6246C30.8768 36.6246 30.9265 36.6213 30.968 36.6147C31.0094 36.6064 31.0458 36.5981 31.0773 36.5898L31.1718 36.9901C31.1287 37.0066 31.0757 37.0215 31.0127 37.0348C30.9497 37.0497 30.8718 37.0572 30.779 37.0572C30.6166 37.0572 30.46 37.0215 30.3092 36.9503C30.1601 36.879 30.0374 36.773 29.9413 36.6321C29.8452 36.4912 29.7971 36.3164 29.7971 36.1076V32.267Z" fill="#A0A3AF"/>
    </svg>

    </div>
   <div 
   className='container' 
   id='events' 
   style={{marginBottom:"50px"}}
   onTouchStart={(e)=>handleTouchStart(e,setStartX)}
    onTouchMove={(e)=>handleTouchMove(e,setEndX)}
    onTouchEnd={()=>handleTouchEnd(startX,endX,setStartX,setEndX,()=> navigate("/tickets"))}
   >
       
       
        {/* {
           searchEvent.length ==0 && searchValue.trim().length >0 && <></>
        }
       
      

        {searchEvent.length >0  && searchEvent.map((event,index)=>{
          if(events.length === index+1){
            return(
              <EventCard event={event} id={event.id} goToEvent={()=>goToEvent(event)} lastEventElementRef={lastEventElementRef}/>
            )
          }else{
            return(
              <EventCard event={event} id={event.id} goToEvent={()=>goToEvent(event)}/>
            )
          }
        })} */}
        {/* searchEvent.length ==0 && searchValue.trim().length === 0 && */}

        {events.map((event,index)=>{
          if(events.length === index+1){
            return(
              <EventCard event={event} id={event.id} goToEvent={()=>goToEvent(event)} lastEventElementRef={lastEventElementRef}/>
            )
          }else{
            return(
              <EventCard event={event} id={event.id} goToEvent={()=>goToEvent(event)}/>
            )
          }
        })}
        <BottomNavEvent selectedIndex={0}/>
    </div>
    {error && <ConfirmationBox title={"Oops! an error occurred"} para={`${error}. swipe down on your screen to refresh`} />}
    </>
  )
}

export default EventsScreen